import { gql } from 'apollo-boost';

const getSelfieCheckResult = gql`
  mutation getSelfieCheckResult($request : GetSelfieCheckResultRequestType!) {
    getSelfieCheckResult(request: $request) {
      complete
      success
      flowId
      signOut
    }
  }
`;

export default getSelfieCheckResult;